const product_groups = {
	add_button: "Productgroep toevoegen",
	add_dialog: {
		description: "Voeg een nieuwe productgroep toe.",
		form: {
			description: "Beschrijving",
			hostfact_number: "Hostfact productnummer (optioneel)",
			hostfact_number_helper: "Alleen invullen als deze groep een samengesteld product simuleert.",
			hostfact_number_not_correct:
				'HostFact productnummer voldoet niet aan de voorwaarden ("P" gevolgd door 3 - 6 getallen).',
			name: "Naam",
		},
		locked_group:
			"Deze groep wordt gebruikt voor achtergrondprocessen en kan niet gewijzigd worden.",
		title: "Productgroep toevoegen",
	},
	add_product_dialog: {
		description: "Voeg een product toe aan de geselecteerde productgroep.",
		form: {
			has_own_invoice_line: "Op aparte factuurregel plaatsen",
			placeholder: "Product toevoegen",
			product_name: "Productnaam",
		},
		title: "Producten selecteren",
	},
	add_product_domain_dialog: {
		description: "Voeg een domein toe aan de geselecteerde productgroep.",
		form: {
			has_own_invoice_line: "Op aparte factuurregel plaatsen",
			product_name: "Domeinnaam",
		},
		title: "Domein toevoegen",
	},
	delete_dialog: {
		description: "Wilt u productgroep <strong>{{name}}</strong> echt verwijderen?",
		group_not_empty: {
			description:
				"Er zijn nog producten gekoppeld aan deze productgroep. Ontkoppel deze voordat u de productgroep verwijdert.",
			title: "Groep is niet leeg.",
		},
		title: "Productgroep verwijderen",
	},
	disconnect_product: {
		description: "Wilt u product <strong>{{name}}</strong> echt ontkoppelen?",
		success_alert: "Ontkoppelen van product is gelukt!",
		title: "Product ontkoppelen",
		unknown_alert: "Ontkoppelen van product is niet gelukt! Probeert u het later opnieuw.",
	},
	duplicate_dialog: {
		description:
			"Voeg een nieuwe productgroep toe met gebruik van de waarden van de geselecteerde productgroep.",
		title: "Productgroep toevoegen",
	},
	edit_dialog: {
		description: "Bewerk de geselecteerde productgroep.",
		title: "Productgroep bewerken",
	},
	single_title: "Product groep",

	status: {
		add_product: {
			success:
				"Product <strong>{{product_name}}</strong> is succesvol toegevoegd aan de productgroep!",
			unknown:
				"Product <strong>{{product_name}}</strong> kan op dit moment niet worden toegevoegd aan de productgroep. Probeert u het later opnieuw.",
		},
		add_product_domain: {
			success:
				"Domein <strong>{{product_name}}</strong> is succesvol toegevoegd aan de productgroep!",
			unknown:
				"Domein <strong>{{product_name}}</strong> kan op dit moment niet worden toegevoegd aan de productgroep. Probeert u het later opnieuw.",
		},
		create: {
			success: "Productgroep is toegevoegd!",
			unknown:
				"Er kan op dit moment geen Productgroep worden toegevoegd. Probeert u het later opnieuw.",
		},
		delete: {
			not_empty:
				"Productgroep kan niet worden verwijderd, omdat er nog producten aan gekoppeld zijn.",
			success: "Productgroep is verwijderd!",
			unknown:
				"Er kan op dit moment geen Productgroep worden verwijderd. Probeert u het later opnieuw.",
		},
		disconnect_product: {
			success: "Product is succesvol ontkoppeld!",
			unknown: "Product kan op dit moment niet worden ontkoppeld. Probeert u het later opnieuw.",
		},
		edit: {
			success: "Productgroep is gewijzigd!",
			unknown:
				"De gekozen productgroep kan op dit moment niet worden gewijzigd. Probeert u het later opnieuw.",
		},
	},
	table: {
		description: "Omschrijving",
		details: "Details",
		name: "Naam",
		number: "Groepsnummer",
		products: "Algemene producten",
		products_domain: "Domein producten",
	},
	title: "Product groepen",
};

export default product_groups;
